<template>
    <q-layout view="lhr lpr lfr">
        <q-header>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle">
                <template #right-top>
                    <router-link :to="{name:'caseidStart'}">Home</router-link> |
                    Logged in as <strong>{{ userDisplayName }}</strong> |
                    <router-link :to="{name: 'logout'}">Log out</router-link>
                </template>
            </gfk-header>
        </q-header>
        <q-page-container>
            <div class="row gutter-xs">
                <div class="col-lg-12" style="width: 100%;">
                    <q-card class="bg-white no-margin">
                        <q-card-section>
                            <div class="row items-center gutter-md">
                                <div class="no-wrap col" style="margin-bottom: 20px">
                                    <q-btn class="gfk-bg-primary text-white" size="lg" @click="downloadRemediation">Download</q-btn>
                                </div>
                            </div>
                            <div class="no-wrap">
                                <formatted-request :records="remediationData" />
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
        </q-page-container>
        <gfk-footer />
    </q-layout>
</template>

<script>
import {
    QLayout, QBtn, QInput, QCard, QPageContainer, QCardSection, QHeader, QFooter
} from 'quasar';

import gfkHeader from './gfk-header.vue';
import gfkFooter from './gfk-footer.vue';
import authenticateApi from '../api/auth';
import RemediationApi from '../api/remediation';
import siteData from '../mixins/site-data-mixin';
import FormattedRequest from './formatted-request.vue';

export default {
    mixins: [siteData],
    components: {
        QLayout,
        QInput,
        QCard,
        QCardSection,
        gfkHeader,
        gfkFooter,
        QBtn,
        FormattedRequest,
        QHeader,
        QPageContainer,
        QFooter
    },
    data: () => ({
        remediationData: []
    }),
    mounted() {
        RemediationApi.get(this.$route.params.id).then((data) => {
            this.remediationData = data;
        }).catch(() => {
            console.log('Permalink not found!');
            this.$router.push({ name: 'caseidStart' });
        });
    },
    computed: {
        userDisplayName() {
            return authenticateApi.getUsername();
        }
    },
    methods: {
        downloadRemediation() {
            this.$router.push({ name: 'permalinkViewDownload', params: { id: this.$route.params.id } });
        }
    }
};
</script>
